// src/mockData/mockProducts.js

const mockProducts = [
  // CAMIONES ESPECIALIZADOS
  {
    id: 1,
    name: "Camión Aljibe Mercedes Benz",
    slug: "camion-aljibe-mercedes-benz-2020",
    description:
      "Camión aljibe Mercedes Benz 2020 con tanque de 15.000 litros. Motor OM936 de 360HP. Excelente para transporte de agua.",
    price: "$95.800.000",
    priceIVA: "+ IVA",
    category: "Camiones",
    image: "/images/camion-aljibe.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2020,
    kilometers: "10.000 km",
    model: "Mercedes Benz Atego 2426",
    estado: "Excelente",
    capacidad: "15.000 litros",
    motor: "OM936 - 360HP",
    ubicacion: "Santiago, Chile",
    features: ["15.000L", "Mercedes", "Bajo kilometraje", "Excelente estado"],
  },
  {
    id: 2,
    name: "Camión Tolva Volvo FMX",
    slug: "camion-tolva-volvo-fmx-2019",
    description:
      "Camión tolva Volvo FMX 2019 para transporte de áridos. Motor D13K de 460HP. Tolva basculante de 20m³.",
    price: "$125.500.000",
    priceIVA: "+ IVA",
    category: "Camiones",
    image: "/images/camion-tolva.jpg",
    condition: "usado-excelente",
    stock: 2,
    year: 2019,
    kilometers: "85.000 km",
    model: "Volvo FMX 6x4",
    estado: "Muy bueno",
    capacidad: "20m³",
    motor: "D13K - 460HP",
    ubicacion: "Valparaíso, Chile",
    features: ["20m³", "Basculante", "460HP", "Volvo FMX"],
  },
  {
    id: 3,
    name: "Camión Mixer Scania P410",
    slug: "camion-mixer-scania-p410-2021",
    description:
      "Camión mixer Scania P410 2021 para hormigón. Tambor de 9m³, motor DC13 de 410HP. Pocas horas de uso.",
    price: "$185.200.000",
    priceIVA: "+ IVA",
    category: "Camiones",
    image: "/images/camion-mixer.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "25.000 km",
    model: "Scania P410 8x4",
    estado: "Como nuevo",
    capacidad: "9m³ hormigón",
    motor: "DC13 - 410HP",
    ubicacion: "Concepción, Chile",
    features: ["9m³", "Scania", "Pocas horas", "Como nuevo"],
  },
  {
    id: 4,
    name: "Camión Grúa Liebherr LTM 1060",
    slug: "camion-grua-liebherr-ltm-1060",
    description:
      "Camión grúa Liebherr LTM 1060 de 60 toneladas. Pluma telescópica de 48m. Motor Mercedes de 367HP.",
    price: "$380.000.000",
    priceIVA: "+ IVA",
    category: "Grúas",
    image: "/images/grua-liebherr.jpg",
    condition: "usado-bueno",
    stock: 1,
    year: 2018,
    kilometers: "120.000 km",
    model: "Liebherr LTM 1060-2",
    estado: "Bueno",
    capacidad: "60 toneladas",
    motor: "Mercedes OM471 - 367HP",
    ubicacion: "Santiago, Chile",
    features: ["60 ton", "Pluma 48m", "Liebherr", "Mercedes"],
  },
  {
    id: 5,
    name: "Excavadora Caterpillar 336F",
    slug: "excavadora-caterpillar-336f-2020",
    description:
      "Excavadora Caterpillar 336F modelo 2020. Motor C9.3B de 268HP. Peso operativo 36 toneladas.",
    price: "$165.000.000",
    priceIVA: "+ IVA",
    category: "Excavadoras",
    image: "/images/excavadora-336f.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2020,
    kilometers: "3.500 horas",
    model: "Caterpillar 336F L",
    estado: "Excelente",
    capacidad: "1.8m³ balde",
    motor: "C9.3B - 268HP",
    ubicacion: "Antofagasta, Chile",
    features: ["36 ton", "268HP", "Pocas horas", "Cat 336F"],
  },
  {
    id: 6,
    name: "Bulldozer Komatsu D65PX",
    slug: "bulldozer-komatsu-d65px-2019",
    description:
      "Bulldozer Komatsu D65PX-18 del 2019. Motor SAA6D114E de 217HP. Hoja recta de 3.7m.",
    price: "$145.800.000",
    priceIVA: "+ IVA",
    category: "Bulldozers",
    image: "/images/bulldozer-d65.jpg",
    condition: "usado-bueno",
    stock: 2,
    year: 2019,
    kilometers: "4.200 horas",
    model: "Komatsu D65PX-18",
    estado: "Muy bueno",
    capacidad: "Hoja 3.7m",
    motor: "SAA6D114E - 217HP",
    ubicacion: "La Serena, Chile",
    features: ["217HP", "Hoja 3.7m", "Komatsu", "4200h"],
  },
  {
    id: 7,
    name: "Cargador Frontal CAT 966M",
    slug: "cargador-frontal-cat-966m-2021",
    description:
      "Cargador frontal Caterpillar 966M del 2021. Motor C13 de 304HP. Balde de 4.2m³. Cabina ROPS/FOPS.",
    price: "$195.500.000",
    priceIVA: "+ IVA",
    category: "Cargadores",
    image: "/images/cargador-966m.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "2.800 horas",
    model: "Caterpillar 966M",
    estado: "Como nuevo",
    capacidad: "4.2m³ balde",
    motor: "C13 - 304HP",
    ubicacion: "Santiago, Chile",
    features: ["304HP", "4.2m³", "ROPS/FOPS", "Pocas horas"],
  },
  {
    id: 8,
    name: "Tractor John Deere 8370R",
    slug: "tractor-john-deere-8370r-2020",
    description:
      "Tractor John Deere 8370R del 2020. Motor 9.0L de 370HP. Transmisión e23 PowerShift. GPS StarFire 6000.",
    price: "$285.000.000",
    priceIVA: "+ IVA",
    category: "Tractores",
    image: "/images/tractor-8370r.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2020,
    kilometers: "1.500 horas",
    model: "John Deere 8370R",
    estado: "Excelente",
    capacidad: "PTO 370HP",
    motor: "9.0L - 370HP",
    ubicacion: "Temuco, Chile",
    features: ["370HP", "GPS", "PowerShift", "Pocas horas"],
  },
  {
    id: 9,
    name: "Montacargas Toyota 8FBE25",
    slug: "montacargas-toyota-8fbe25-2022",
    description:
      "Montacargas eléctrico Toyota 8FBE25 del 2022. Capacidad 2.5 toneladas. Batería de ion-litio. Mástil triplex.",
    price: "$42.800.000",
    priceIVA: "+ IVA",
    category: "Montacargas",
    image: "/images/montacargas-8fbe25.jpg",
    condition: "usado-excelente",
    stock: 3,
    year: 2022,
    kilometers: "800 horas",
    model: "Toyota 8FBE25",
    estado: "Como nuevo",
    capacidad: "2.5 toneladas",
    motor: "Eléctrico - Ion-Litio",
    ubicacion: "Santiago, Chile",
    features: ["2.5 ton", "Ion-litio", "Triplex", "Toyota"],
  },
  {
    id: 10,
    name: "Generador Caterpillar C18",
    slug: "generador-caterpillar-c18-2021",
    description:
      "Generador Caterpillar C18 del 2021. Potencia 600KVA. Motor diesel C18 ACERT. Tablero de control digital.",
    price: "$125.000.000",
    priceIVA: "+ IVA",
    category: "Generadores",
    image: "/images/generador-c18.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "500 horas",
    model: "Caterpillar C18",
    estado: "Excelente",
    capacidad: "600KVA",
    motor: "C18 ACERT Diesel",
    ubicacion: "Valparaíso, Chile",
    features: ["600KVA", "C18 ACERT", "Digital", "Pocas horas"],
  },
  {
    id: 11,
    name: "Generador Caterpillar C18",
    slug: "generador-caterpillar-c18-2021",
    description:
      "Generador Caterpillar C18 del 2021. Potencia 600KVA. Motor diesel C18 ACERT. Tablero de control digital.",
    price: "$125.000.000",
    priceIVA: "+ IVA",
    category: "Generadores",
    image: "/images/generador-c18.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "500 horas",
    model: "Caterpillar C18",
    estado: "Excelente",
    capacidad: "600KVA",
    motor: "C18 ACERT Diesel",
    ubicacion: "Valparaíso, Chile",
    features: ["600KVA", "C18 ACERT", "Digital", "Pocas horas"],
  },
  {
    id: 12,
    name: "Retroexcavadora JCB 3CX",
    slug: "retroexcavadora-jcb-3cx-2020",
    description:
      "Retroexcavadora JCB 3CX del 2020. Motor JCB EcoMAX de 109HP. Transmisión PowerShift de 6 velocidades.",
    price: "$78.500.000",
    priceIVA: "+ IVA",
    category: "Excavadoras",
    image: "/images/retroexcavadora-jcb.jpg",
    condition: "usado-excelente",
    stock: 2,
    year: 2020,
    kilometers: "2.100 horas",
    model: "JCB 3CX-14",
    estado: "Excelente",
    capacidad: "0.3m³ balde trasero",
    motor: "JCB EcoMAX - 109HP",
    ubicacion: "Rancagua, Chile",
    features: ["109HP", "PowerShift", "JCB", "Pocas horas"],
  },
  {
    id: 13,
    name: "Minicargador Bobcat S650",
    slug: "minicargador-bobcat-s650-2022",
    description:
      "Minicargador Bobcat S650 del 2022. Motor Kubota V2607 de 74HP. Capacidad de elevación 1.270 kg.",
    price: "$58.200.000",
    priceIVA: "+ IVA",
    category: "Cargadores",
    image: "/images/minicargador-bobcat.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2022,
    kilometers: "650 horas",
    model: "Bobcat S650",
    estado: "Como nuevo",
    capacidad: "1.270 kg elevación",
    motor: "Kubota V2607 - 74HP",
    ubicacion: "Santiago, Chile",
    features: ["74HP", "1270kg", "Bobcat", "Como nuevo"],
  },
  {
    id: 14,
    name: "Camión Pluma Iveco Eurocargo",
    slug: "camion-pluma-iveco-eurocargo-2019",
    description:
      "Camión con pluma Iveco Eurocargo 2019. Pluma telescópica de 18m. Motor F4AE3681 de 190HP.",
    price: "$89.800.000",
    priceIVA: "+ IVA",
    category: "Camiones",
    image: "/images/camion-pluma-iveco.jpg",
    condition: "usado-bueno",
    stock: 1,
    year: 2019,
    kilometers: "95.000 km",
    model: "Iveco Eurocargo 120E25",
    estado: "Muy bueno",
    capacidad: "Pluma 18m",
    motor: "F4AE3681 - 190HP",
    ubicacion: "Viña del Mar, Chile",
    features: ["18m pluma", "190HP", "Iveco", "Telescópica"],
  },
  {
    id: 15,
    name: "Compactadora Dynapac CA512",
    slug: "compactadora-dynapac-ca512-2021",
    description:
      "Compactadora vibratoria Dynapac CA512 del 2021. Rodillo liso de 2.134mm. Motor Cummins QSB4.5 de 129HP.",
    price: "$98.500.000",
    priceIVA: "+ IVA",
    category: "Compactadoras",
    image: "/images/compactadora-dynapac.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "1.800 horas",
    model: "Dynapac CA512",
    estado: "Excelente",
    capacidad: "Rodillo 2.134mm",
    motor: "Cummins QSB4.5 - 129HP",
    ubicacion: "La Serena, Chile",
    features: ["129HP", "Vibratoria", "Cummins", "Dynapac"],
  },
  {
    id: 16,
    name: "Miniexcavadora Kubota U48-4",
    slug: "miniexcavadora-kubota-u48-4-2022",
    description:
      "Miniexcavadora Kubota U48-4 del 2022. Motor Kubota V2607-CR-T de 47.6HP. Peso operativo 4.8 toneladas.",
    price: "$68.900.000",
    priceIVA: "+ IVA",
    category: "Excavadoras",
    image: "/images/miniexcavadora-kubota.jpg",
    condition: "usado-excelente",
    stock: 2,
    year: 2022,
    kilometers: "950 horas",
    model: "Kubota U48-4",
    estado: "Como nuevo",
    capacidad: "0.18m³ balde",
    motor: "Kubota V2607-CR-T - 47.6HP",
    ubicacion: "Temuco, Chile",
    features: ["47.6HP", "4.8 ton", "Kubota", "Turbo"],
  },
  {
    id: 17,
    name: "Motoniveladora CAT 140M3",
    slug: "motoniveladora-cat-140m3-2020",
    description:
      "Motoniveladora Caterpillar 140M3 del 2020. Motor C9.3 de 205HP. Hoja de 3.7m con control hidráulico.",
    price: "$285.000.000",
    priceIVA: "+ IVA",
    category: "Motoniveladoras",
    image: "/images/motoniveladora-cat.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2020,
    kilometers: "3.200 horas",
    model: "Caterpillar 140M3",
    estado: "Excelente",
    capacidad: "Hoja 3.7m",
    motor: "C9.3 - 205HP",
    ubicacion: "Antofagasta, Chile",
    features: ["205HP", "3.7m hoja", "Cat", "Hidráulico"],
  },
  {
    id: 18,
    name: "Camión Baranda Mercedes Atego",
    slug: "camion-baranda-mercedes-atego-2021",
    description:
      "Camión baranda Mercedes Atego 2021. Carga útil 7.5 toneladas. Motor OM936 de 231HP con transmisión automática.",
    price: "$72.800.000",
    priceIVA: "+ IVA",
    category: "Camiones",
    image: "/images/camion-baranda-mercedes.jpg",
    condition: "usado-excelente",
    stock: 3,
    year: 2021,
    kilometers: "45.000 km",
    model: "Mercedes Atego 1418",
    estado: "Excelente",
    capacidad: "7.5 toneladas",
    motor: "OM936 - 231HP",
    ubicacion: "Santiago, Chile",
    features: ["7.5 ton", "Automático", "Mercedes", "231HP"],
  },
  {
    id: 19,
    name: "Soldadora Miller Trailblazer 325",
    slug: "soldadora-miller-trailblazer-325-2020",
    description:
      "Soldadora/Generador Miller Trailblazer 325 del 2020. Motor Kohler de 23HP. Salida 325A soldadura, 11kW generador.",
    price: "$28.500.000",
    priceIVA: "+ IVA",
    category: "Soldadoras",
    image: "/images/soldadora-miller.jpg",
    condition: "usado-excelente",
    stock: 2,
    year: 2020,
    kilometers: "850 horas",
    model: "Miller Trailblazer 325",
    estado: "Excelente",
    capacidad: "325A / 11kW",
    motor: "Kohler - 23HP",
    ubicacion: "Valparaíso, Chile",
    features: ["325A", "11kW", "Miller", "Dual función"],
  },
  {
    id: 20,
    name: "Compresor Atlas Copco XRVS476",
    slug: "compresor-atlas-copco-xrvs476-2021",
    description:
      "Compresor portátil Atlas Copco XRVS476 del 2021. Motor Caterpillar C4.4 de 129HP. Presión 17 bar, 476 CFM.",
    price: "$45.200.000",
    priceIVA: "+ IVA",
    category: "Compresores",
    image: "/images/compresor-atlas.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2021,
    kilometers: "1.200 horas",
    model: "Atlas Copco XRVS476",
    estado: "Excelente",
    capacidad: "476 CFM",
    motor: "Caterpillar C4.4 - 129HP",
    ubicacion: "Concepción, Chile",
    features: ["476 CFM", "17 bar", "Cat C4.4", "Portátil"],
  },
  {
    id: 21,
    name: "Plataforma Elevadora JLG 3246ES",
    slug: "plataforma-elevadora-jlg-3246es-2022",
    description:
      "Plataforma elevadora JLG 3246ES del 2022. Altura de trabajo 11.75m. Motor eléctrico, batería de ion-litio.",
    price: "$38.900.000",
    priceIVA: "+ IVA",
    category: "Plataformas",
    image: "/images/plataforma-jlg.jpg",
    condition: "usado-excelente",
    stock: 1,
    year: 2022,
    kilometers: "480 horas",
    model: "JLG 3246ES",
    estado: "Como nuevo",
    capacidad: "11.75m altura",
    motor: "Eléctrico - Ion-Litio",
    ubicacion: "Santiago, Chile",
    features: ["11.75m", "Eléctrico", "Ion-litio", "JLG"],
  },
];

export default mockProducts;
